import axios from 'axios';

const defaultVerificationMedium = 'SMS';
const defaultVerificationType = 'Stamps';

export const phoneVerificationContract = ({ sellerId, phoneNumber, sellerProviderId, verificationMedium, verificationType }) => {
  if (!sellerId) {
    throw new Error('SellerId is required for Phone Verification');
  }
  if (!phoneNumber) {
    throw new Error('Phone Number is required for Phone Verification');
  }
  if (!sellerProviderId) {
    throw new Error('Seller Provider Id is required for Phone Verification');
  }
  return {
    sellerId,
    phoneNumber,
    sellerProviderId,
    verificationMedium: verificationMedium || defaultVerificationMedium,
    verificationType: verificationType || defaultVerificationType,
  };
};

export const requestChallengeCode = (args) => {
  try {
    const requestBody = {
      ...phoneVerificationContract(args),
    };
    const request = axios.post('/seller/verification/initiate', requestBody);
    return request;
  } catch (e) {
    return Promise.reject(e);
  }
};

const phoneVerificationChallengeContract = ({ publicKey, verificationCode, sellerId, verificationType }) => {
  if (!verificationCode) {
    throw new Error('Verification Code is required for Phone Verification');
  }
  if (!sellerId) {
    throw new Error('SellerId is required for Phone Verification');
  }
  return {
    publicKey,
    verificationCode,
    sellerId,
    verificationType: verificationType || defaultVerificationType,
  };
};

export const requestChallenge = (args) => {
  try {
    const requestBody = {
      ...phoneVerificationChallengeContract(args),
    };
    const request = axios.post('/seller/verification/complete', requestBody);
    return request;
  } catch (e) {
    return Promise.reject(e);
  }
};
